// Adapter: convert a Zod ZodError into the AntD Form-friendly shape so
// schema-side errors land on the right fields with the same callsite as
// API-side `fields` errors.
export function applyZodErrors(zodError, form) {
  const fields = zodError.issues.map((issue) => ({
    name: issue.path,
    errors: [issue.message],
  }));
  form.setFields(fields);
}

export function applyApiFieldErrors(apiError, form) {
  if (!apiError?.fields) return;
  const fields = Object.entries(apiError.fields).map(([name, message]) => ({
    name: name.split('.'),
    errors: [message],
  }));
  form.setFields(fields);
}
